import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useSync } from '@/contexts/SyncContext';
import { usePendingInvitations } from '@/hooks/useShares';
import { InvitationsNavIcon, UnassignedSpendingNavIcon } from '@/components/sharing/SharingUi';
import { NavIconLink } from '@/components/layout/NavIconLink';
import { navIcons } from '@/components/layout/navIcons';
import { BrandMark } from '@/components/brand/BrandMark';
import { UserAvatar } from '@/components/user/UserAvatar';
import { useUnassignedSpending } from '@/hooks/useUnassignedSpending';

export function Header() {
  const { user, logout } = useAuth();
  const { pendingChanges } = useSync();
  const { pendingCount } = usePendingInvitations();
  const { data: unassigned } = useUnassignedSpending();
  const unassignedCount = unassigned?.count ?? 0;

  return (
    <header className="sticky top-0 z-50 hidden border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 md:block">
      <div className="container mx-auto flex h-14 max-w-2xl items-center justify-between px-4 md:max-w-7xl">
        <Link to="/dashboard" className="flex items-center gap-2">
          <BrandMark size={28} alt="" />
          <span className="font-display text-lg font-semibold tracking-tight text-foreground">
            My Budget
          </span>
        </Link>

        <div className="flex items-center gap-1">
          <nav className="flex items-center">
            <NavIconLink to="/dashboard" title="Dashboard" icon={navIcons.transactions} end />
            <NavIconLink to="/budgets" title="Budgets" icon={navIcons.budgets} />
            <InvitationsNavIcon pendingCount={pendingCount} className="p-2" />
            <UnassignedSpendingNavIcon pendingCount={unassignedCount} className="p-2" />
            <NavIconLink
              to="/settings"
              title="Settings"
              icon={
                <UserAvatar
                  picture={user?.picture}
                  name={user?.name ?? user?.givenName ?? user?.displayName}
                  className="h-5 w-5"
                />
              }
            />
            {user?.isAdmin && (
              <NavIconLink to="/admin" title="Global settings" icon={navIcons.admin} />
            )}
          </nav>

          {pendingChanges > 0 && (
            <div className="flex items-center gap-1.5 px-2" title={`${pendingChanges} pending change(s)`}>
              <span className="text-xs text-muted-foreground">{pendingChanges}</span>
            </div>
          )}

          {user && (
            <button
              onClick={logout}
              className="hidden px-2 text-sm text-muted-foreground hover:text-foreground md:block"
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
